export const GROWTHBOOK_EXPERIMENT_VIEWED_EVENT_NAME = "growthbook_experiment_viewed";
